//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../Drawings/Drawings.SelectDraftingViewList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AttributeTitles",1,0],[0,"AttributeValues",1,0],[0,"HoleDiameter",1,0],[0,"HoleTolerance",1,0],[0,"HoleType",1,0],[1,"SelectHoles",0,"SelectNXObjectList",0],[0,"SelectHolesAccordingToAttribute",1,0],[0,"SelectSpreadsheet",1,0],[1,"SelectView",0,"Drawings.SelectDraftingViewList",0],[0,"WizardType",1,0]],[[[],"UpdateSymbolSizeInView",{},0,0],[["viewTag","vseqNumber","isDrawing","inObject"],"CycleObjectsInView",{R_:{outPutObject:"NXObject"}},4,0]],[]];
SPLM.Tooling.HoleDatumSymbolBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.HoleDatumSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.HoleDatumSymbolBuilder.SymbolType = Object.freeze({
    "First" : "First", "Second" : "Second", "Third" : "Third", "Fourth" : "Fourth"});

export default SPLM;